import { Box, CircularProgress } from '@mui/material';

interface Props {
  height?: string;
}

export const Loader = ({ height = '100dvh' }: Props) => (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} height={height}>
    <CircularProgress />
  </Box>
);
